class NavUtils {
	static redirectToRoot() {
		if (window.location.pathname !== '/') {
			window.location.pathname = '/';
		}
	}
	static redirectToDashboard() {
		if (window.location.pathname !== '/dashboard') {
			window.location.pathname = '/dashboard';
		}
	}
	static redirectToUsers() {
		if (window.location.pathname !== '/users') {
			window.location.pathname = '/users';
		}
	}
}

export default NavUtils;